const blogPosts = [
  {
    id: '8',
    title: 'Curious Facts About Granada with Your Ultimate Audio Guide App',
    slug: 'curious-facts-granada',
    createdAt: '2026-01-05T18:19:00Z',
    isPublished: true,
    content: '/blog-content/curious-facts-granada/curious-facts-granada.md',
    description: 'Curious facts about Granada with TravelMaker - the best audio guide app!'
  },
  {
    id: '7',
    title: 'Discover the Magic of Granada: A Journey Through Time with Your AI Travel Companion',
    slug: 'discover-magic-of-granada',
    createdAt: '2025-12-26T19:50:00Z',
    isPublished: true,
    content: '/blog-content/discover-magic-of-granada/discover-magic-of-granada.md',
    description: 'Discover the magic of Granada and visit Granada with TravelMaker - the best audio guide app!'
  },
  {
    id: '6',
    title: 'Curious Facts About Amsterdam: Your Ultimate City Guide to the Venice of the North',
    slug: 'curious-facts-amsterdam',
    createdAt: '2025-12-16T10:00:00Z',
    isPublished: true,
    content: '/blog-content/curious-facts-amsterdam/curious-facts-amsterdam.md',
    description: 'Get to know curious facts about Amsterdam with TravelMaker, your AI-powered audio guide.'
  },
  {
    id: '5',
    title: '5 Highlights You Cannot Miss in Amsterdam: Your Ultimate City Guide',
    slug: '5-highlights-amsterdam',
    createdAt: '2025-12-06T10:00:00Z',
    isPublished: true,
    content: '/blog-content/5-highlights-amsterdam/5-highlights-amsterdam.md',
    description: 'Discover the top 5 unmissable highlights in Amsterdam with TravelMaker, your AI-powered audio guide.'
  },
  {
    id: '4',
    title: 'Introducing TravelMaker: Your AI-Powered Travel Companion and Audio Guide',
    slug: 'introducing-travelmaker',
    thumbnail: '/images/travelmaker-banner-new.jpg',
    createdAt: '2025-09-27T10:00:00Z',
    isPublished: true,
    content: '/blog-content/introducing-travelmaker.md',
    description: 'Learn how TravelMaker, your new AI-powered audio guide and travel companion, is revolutionizing the way you explore the world.' // New description field
  },
];

export default blogPosts;